import { motion } from 'framer-motion';
import styled from 'styled-components';

export const DrawerWrapper = styled(motion.div)`
    position: fixed;
    bottom: 0;
    height: fit-content;
    /* max-height: ; */
    width: 100%;
    max-width: 40rem;
    background-color: rgb(0, 0, 0, 0.5);
    backdrop-filter: blur(30px);

    /* transition: transform 0.3s ease-in-out; */
    z-index: 1000;
    overflow-y: auto;

    padding: 2rem 3rem;
    border-radius: 1.5rem;

    border-end-end-radius: 0;
    border-end-start-radius: 0;

    &.nav-options-drawer {
        padding: 1.5rem 2rem;
    }
`;

export const Overlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    transition: background 0.3s ease-in-out;

    display: flex;
    justify-content: center;

    backdrop-filter: blur(2px);
`;
